



































































import * as moment from "moment"
import { updatePhotosURL, URLBuilder, isRTL} from '../../helpers'
import { Vue, cookies, servicesURL, webClientID, photosUrlEnum, requestHeaders, getCookie, headers } from '../../constants/constants'
import {
  staticContent
} from '../../localisation/detect-lang';
import axios from 'axios';
import CoolLightBox from 'vue-cool-lightbox'

export default Vue.component('review-card', {
  data(){
    return {
      photosUrlEnum,
      staticContent,
      URLBuilder,
      items: [],
      index: null
    }
  },
  components: {
    CoolLightBox,
  },
  props: {
    review: {
      required: true,
      type: Object
    }
  },
  mounted(){
    
      this.review.data.photos.map(photo=>{
        let obj={
                title: null,
                description: null,
                src:null,
              }
        obj.src=photo.data.photoUrl.replace("{{PHOTO_VERSION}}","Normal").replace("{{PHOTO_EXTENSION}}",'jpg')
        if(photo.ref.item){
           obj.title=photo.ref.item.data.name
        }
        this.items.push(obj)
      })   
           
  },
  computed: {
    helpfulMethod () {
      return 'POST'
    },
    userLang () {
      return isRTL ? 'AR': 'EN'
    },
    profile(){
      return this.$root.profile
    }
  },
  methods: {
    openLightBox(imageIndex){
      this.index = imageIndex

          if(this.items.length<=1){
            setTimeout(() => {
               document.getElementsByClassName('cool-lightbox-button--prev')[0].classList.add('hide-controls')
        document.getElementsByClassName('cool-lightbox-button--next')[0].classList.add('hide-controls')
            }, 100);
       
          }
    },
    updatePhotosURL(url, version, ext = this.photosUrlEnum.ext.JPG){
      return updatePhotosURL(url, version, ext)
    },
    getFormattedDate (date) {
      return moment(date).fromNow()
    },
    markReviewAsHelpful (reviewUUID) {
      axios({
        method: this.helpfulMethod,
        url: servicesURL.review.markAsHelpful(reviewUUID),
        headers
      })
      .then(res => {
        console.log("res", res.data)
      })
      .catch(error => {
          console.log("error", error)
      });
    }
  }
})
